import rootconfig from 'config'

let locale = '/' + rootconfig.locale

if (process.env.NODE_ENV === 'development') {
  locale = ''
}

export const config = {
  // should be discussed where in config this should be store
  // needs to be changed after functions are merged to main in lusini_functions - repo
  shareCart: {
    url: locale + '/cart?share=',
    netlifyPostFn:
      'https://functions.lusini.com/.netlify/functions/shareCart-POST',
    netlifyGetFn:
      'https://functions.lusini.com/.netlify/functions/shareCart-GET'
  }
}
